/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SyncSlackDirectoryRequestBody = {
  /**
   * Generation last read by the administrator.
   */
  generation: string;
  /**
   * Connection to sync.
   */
  id: string;
};

/** @internal */
export type SyncSlackDirectoryRequestBody$Outbound = {
  generation: string;
  id: string;
};

/** @internal */
export const SyncSlackDirectoryRequestBody$outboundSchema: z.ZodMiniType<
  SyncSlackDirectoryRequestBody$Outbound,
  SyncSlackDirectoryRequestBody
> = z.object({
  generation: z.string(),
  id: z.string(),
});

export function syncSlackDirectoryRequestBodyToJSON(
  syncSlackDirectoryRequestBody: SyncSlackDirectoryRequestBody,
): string {
  return JSON.stringify(
    SyncSlackDirectoryRequestBody$outboundSchema.parse(
      syncSlackDirectoryRequestBody,
    ),
  );
}
